import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import '../scss/style.scss';

function initHero() {
  const heroEl = document.querySelector<HTMLElement>('.hero__carousel');
  if (!heroEl) return;
  new Splide(heroEl, {
    type: 'loop',
    perPage: 2,
    perMove: 1,
    focus: 'center',
    gap: 0,
    pagination: true,
    arrows: true,
    breakpoints: {
      736: {
        perPage: 1,
        gap: 0,
      },
    },
  }).mount();
}

function initDrawer() {
  const drawer = document.querySelector<HTMLElement>('[data-drawer]');
  const hamburger = document.querySelector<HTMLButtonElement>('.header__hamburger');
  if (!drawer || !hamburger) return;

  const overlay = drawer.querySelector<HTMLElement>('[data-drawer-overlay]');
  const toggles = drawer.querySelectorAll<HTMLButtonElement>('.header__drawer-toggle');

  const open = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-label', 'メニューを閉じる');
    document.body.classList.add('is-drawer-open');
  };

  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-label', 'メニューを開く');
    document.body.classList.remove('is-drawer-open');
    toggles.forEach((t) => {
      t.setAttribute('aria-expanded', 'false');
      t.closest('.header__drawer-item')?.classList.remove('is-expanded');
    });
  };

  hamburger.addEventListener('click', () => {
    if (drawer.classList.contains('is-open')) {
      close();
    } else {
      open();
    }
  });
  overlay?.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const wasExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggles.forEach((t) => {
        t.setAttribute('aria-expanded', 'false');
        t.closest('.header__drawer-item')?.classList.remove('is-expanded');
      });
      if (!wasExpanded) {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.closest('.header__drawer-item')?.classList.add('is-expanded');
      }
    });
  });
}

function initSpMegaMenu() {
  const navItems = document.querySelectorAll<HTMLElement>(
    '.header__nav-item--has-mega'
  );
  if (navItems.length === 0) return;

  const overlay = document.querySelector<HTMLElement>('[data-mega-overlay]');
  const mq = window.matchMedia('(max-width: 736px)');

  const isSP = () => mq.matches;

  const collapseAll = () => {
    navItems.forEach((item) => item.classList.remove('is-expanded'));
    overlay?.classList.remove('is-active');
  };

  navItems.forEach((item) => {
    const trigger = item.querySelector<HTMLElement>(':scope > a, :scope > button');
    if (!trigger) return;

    const isButton = trigger.tagName === 'BUTTON';

    trigger.addEventListener('click', (e) => {
      // PC では <a> は通常リンクとして遷移、<button> のみ click で展開
      // SP では両方とも click で展開
      if (!isSP() && !isButton) return;
      e.preventDefault();
      const wasExpanded = item.classList.contains('is-expanded');
      collapseAll();
      if (!wasExpanded) {
        item.classList.add('is-expanded');
        overlay?.classList.add('is-active');
      }
    });
  });

  overlay?.addEventListener('click', collapseAll);

  // PC ⇄ SP のリサイズ時、SP 専用の展開状態を解除
  mq.addEventListener('change', () => {
    if (!isSP()) collapseAll();
  });
}

function initNavScrollIndicators() {
  const nav = document.querySelector<HTMLElement>('.header__nav');
  const leftIndicator = document.querySelector<HTMLElement>('.header__scroll-indicator--left');
  const rightIndicator = document.querySelector<HTMLElement>('.header__scroll-indicator--right');
  if (!nav || !leftIndicator || !rightIndicator) return;

  // ヒステリシス: 現在表示中の側が反対側より少なくとも 20px 多い時のみ切り替え（境界でのチラつき防止）
  const HYSTERESIS = 20;
  // スクロール余地が 5px 未満なら「ない」とみなす
  const EPS = 5;
  let currentSide: 'left' | 'right' | null = null;

  const update = () => {
    const leftRoom = nav.scrollLeft;
    const rightRoom = nav.scrollWidth - nav.clientWidth - nav.scrollLeft;

    if (leftRoom < EPS && rightRoom < EPS) {
      leftIndicator.classList.remove('is-visible');
      rightIndicator.classList.remove('is-visible');
      currentSide = null;
      return;
    }

    let nextSide: 'left' | 'right';
    if (currentSide === null) {
      nextSide = leftRoom > rightRoom ? 'left' : 'right';
    } else if (currentSide === 'left' && rightRoom > leftRoom + HYSTERESIS) {
      nextSide = 'right';
    } else if (currentSide === 'right' && leftRoom > rightRoom + HYSTERESIS) {
      nextSide = 'left';
    } else {
      nextSide = currentSide;
    }

    if (nextSide !== currentSide) {
      currentSide = nextSide;
      leftIndicator.classList.toggle('is-visible', nextSide === 'left');
      rightIndicator.classList.toggle('is-visible', nextSide === 'right');
    }
  };

  nav.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

window.addEventListener('DOMContentLoaded', () => {
  initHero();
  initDrawer();
  initSpMegaMenu();
  initNavScrollIndicators();
});
